import { useTranslation } from 'react-i18next';

import { PackageRowActionType } from '../../types.ts';

export const usePackageRowActionTranslate = () => {
  const { t } = useTranslation();

  return {
    [PackageRowActionType.DETAILS]: t('Details'),
    [PackageRowActionType.CLONE]: t('Clone'),
    [PackageRowActionType.EDIT]: t('Edit'),
    [PackageRowActionType.DELETE]: t('Delete'),
    [PackageRowActionType.CREATE_DEAL]: t('Create'),
  };
};
